import { all, call, put, takeLatest } from "redux-saga/effects";
import { getFlowStart } from "../selectors/flow";
import { endFlow, startFlow } from "../actions/flow";
import { getConfiguration } from "../services/configurationService";
import { insertAudio } from "../stores/audio-store";
import { requestMergeConfiguration } from "../actions/configuration";
import { LOAD_CONFIGURATION_FLOW } from "../consts";
import { logError } from "../util";

let errorCount = 0;

export default function* () {
  yield takeLatest(getFlowStart(LOAD_CONFIGURATION_FLOW), function* () {
    try {
      const configuration = yield call(getConfiguration);
      yield put(requestMergeConfiguration(configuration));
      yield all(
        [
          "correctAudios",
          "errorAudios",
          "firstTryAudios",
          "secondTryAudios",
          "speechRecognitionErrorAudios",
          "userAwayAudios",
          "optionAudios",
        ].reduce(async (acc, path) => {
          await acc;

          await Promise.all(
            configuration[path].map(async (item) => {
              await insertAudio({
                isCompleteUrl: false,
                isDeletable: false,
                url: item.path || item.generatedAudio,
              });
              return item;
            })
          );
        }, Promise.resolve())
      );

      yield put(requestMergeConfiguration(configuration));
      errorCount = 0;
    } catch (error) {
      logError({ error, flow: LOAD_CONFIGURATION_FLOW });
      errorCount += 1;
    } finally {
      yield put(endFlow(LOAD_CONFIGURATION_FLOW));
      if (errorCount > 0 && errorCount < 4) {
        yield put(startFlow(LOAD_CONFIGURATION_FLOW));
      }
    }
  });
}
